import { render, staticRenderFns } from "./TypeForm.vue?vue&type=template&id=f12781aa&"
import script from "./TypeForm.vue?vue&type=script&lang=js&"
export * from "./TypeForm.vue?vue&type=script&lang=js&"
import style0 from "./TypeForm.vue?vue&type=style&index=0&id=f12781aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports